<template>
  <div class="internal-parts-listing">
    <div class="p-2 pr-0 border-bottom-light-grey">
      <v-text-field
        v-if="serialized > 0"
        v-model.trim="search"
        v-on:click:clear="(search = null), getProductInventory(type_id)"
        clearable
        dense
        filled
        flat
        label="Search Serial Number"
        hide-details
        solo
        :loading="pageLoading"
        :disabled="pageLoading"
        color="cyan"
        @keydown.enter="getProductInventory(type_id)"
        @keydown.tab="getProductInventory(type_id)"
        class="inventory-search"
      ></v-text-field>

      <v-row v-if="serialized > 0" class="inventory-filter-row mb-0">
        <v-col
          v-for="filter in stockFilters"
          :key="filter.value"
          cols="12"
          sm="4"
          class="pt-0 inventory-filter-col"
        >
          <v-card
            class="inventory-filter-card"
            :class="{ 'inventory-filter-card--active': stockFilter === filter.value }"
            outlined
            role="button"
            tabindex="0"
            :aria-pressed="stockFilter === filter.value ? 'true' : 'false'"
            @click="selectStockFilter(filter.value)"
            @keydown.enter="selectStockFilter(filter.value)"
            @keydown.space.prevent="selectStockFilter(filter.value)"
          >
            <div class="inventory-filter-icon" :class="filter.iconClass">
              <v-icon>{{ filter.icon }}</v-icon>
            </div>
            <div class="inventory-filter-label">{{ filter.label }}</div>
            <div class="inventory-filter-count" :class="filter.iconClass">
              {{ filter.count }}
            </div>
          </v-card>
        </v-col>
      </v-row>
    </div>
    <template v-if="serialized > 0">
      <InventorySerialTable
        :inventoryData="inventoryData"
        :loading="pageLoading"
        :inbondDate="inbondDate"
        :inbondDoc="inbondDoc"
        :key="`product-serialization-${inventoryKey}`"
      />
    </template>
    <template v-else>
      <NonInventorySerialTable
        :inventoryData="inventoryData"
        :loading="pageLoading"
        :inbondDate="inbondDate"
        :inbondDoc="inbondDoc"
        :key="`product-non-serialization-${inventoryKey}`"
      />
    </template>

    <ListingFooter
      :dataLoading="pageLoading"
      :currentPage="current_page"
      :totalPages="total_pages"
      :showingFrom="showingFrom"
      :showingTo="showingTo"
      :totalRows="total_rows"
      removePage
    ></ListingFooter>
  </div>
</template>

<script>
import { QUERY } from "@/core/services/store/request.module";
import CommonMixin from "@/core/plugins/common-mixin";
import ListingFooter from "@/view/pages/partials/Listing-Footer";
import { PaginationEventBus } from "@/core/lib/pagination.lib";
/* import showBarcode from "@/view/components/showBarcode.vue"; */
// import moment from "moment-timezone";
/* import Barcode from "@/view/pages/partials/Barcode.vue"; */
/* import TableActivity from "@/view/pages/partials/Table-Activity.vue"; */
import InventorySerialTable from "@/view/pages/part/detail/Serialized-Inventory.vue";
import NonInventorySerialTable from "@/view/pages/part/detail/Non-Serialized-Inventory.vue";

export default {
  mixins: [CommonMixin],
  data() {
    return {
      dates: [],
      pageLoading: false,
      inventoryData: new Array(),
      search: null,
      stockFilter: "all",
      stockCounts: {
        all: 0,
        in_stock: 0,
        out_of_stock: 0,
      },
      per_page: 15,
      current_page: 1,
      offset: 0,
      total_pages: 0,
      total_rows: 0,
      inventoryKey: Number(new Date()),
    };
  },
  components: {
    ListingFooter,
    /*  showBarcode, */
    /* Barcode, */
    /*  TableActivity, */
    InventorySerialTable,
    NonInventorySerialTable,
  },
  props: {
    type: {
      required: true,
      type: String,
      default: "",
    },
    type_id: {
      required: true,
      type: Number,
      default: 0,
    },
    serialized: {
      type: Number,
      default: 0,
    },
    inbondDate: {
      type: String,
      default: null,
    },
    inbondDoc: {
      type: String,
      default: null,
    },
  },
  watch: {
    type_id() {
      let type_id = this.lodash.toSafeInteger(this.type_id);
      if (type_id > 0) {
        this.getProductInventory(type_id);
      }
    },
  },
  methods: {
    getProductInventory(productId) {
      const _this = this;
      _this.inventoryData = [];
      _this.pageLoading = true;
      _this.$store
        .dispatch(QUERY, {
          url: `all-serial-number/${this.type}/${productId}`,
          data: {
            //type: _this.type,
            per_page: _this.per_page,
            current_page: _this.current_page,
            search: _this.search,
            activated: _this.stockFilter === "all" ? null : _this.stockFilter === "in_stock" ? 1 : 0,
          },
        })
        .then((data) => {
          this.inventoryData = data.data.rows;
          this.stockCounts = data.data.stock_counts || this.stockCounts;
          _this.offset = data.data.offset;
          _this.total_pages = Math.ceil(
            data.data.total_rows / data.data.per_page
          );
          _this.current_page = data.data.current_page;
          _this.total_rows = data.data.total_rows;
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },
    onStockFilterChange() {
      this.current_page = 1;
      this.getProductInventory(this.type_id);
    },
    selectStockFilter(filter) {
      if (this.stockFilter !== filter) {
        this.stockFilter = filter;
        this.onStockFilterChange();
      }
    },
  },
  beforeDestroy() {
    PaginationEventBus.$off("update:pagination");
  },
  mounted() {
    const _this = this;
    let type_id = _this.lodash.toSafeInteger(_this.type_id);
    if (type_id > 0) {
      _this.getProductInventory(type_id);
    }

    PaginationEventBus.$on("update:pagination", (param) => {
      _this.current_page = param;
      _this.getProductInventory(_this.type_id);
    });
  },
  computed: {
    stockFilters() {
      return [
        {
          value: "all",
          label: "All",
          count: this.stockCounts.all,
          icon: "mdi-view-grid-outline",
          iconClass: "inventory-filter-icon--all",
        },
        {
          value: "in_stock",
          label: "In Stock",
          count: this.stockCounts.in_stock,
          icon: "mdi-package-variant-closed",
          iconClass: "inventory-filter-icon--in-stock",
        },
        {
          value: "out_of_stock",
          label: "Out of Stock",
          count: this.stockCounts.out_of_stock,
          icon: "mdi-close-circle-outline",
          iconClass: "inventory-filter-icon--out-stock",
        },
      ];
    },
    showingFrom() {
      return this.lodash.isEmpty(this.inventoryData) === false
        ? this.offset + 1
        : 0;
    },
    showingTo() {
      return this.offset + (this.inventoryData ? this.inventoryData.length : 0);
    },
  },
};
</script>

<style scoped>
.inventory-search {
  max-width: 295px;
}

.inventory-filter-col {
  box-sizing: border-box;
  flex: 0 0 33.333333% !important;
  max-width: 33.333333% !important;
  min-width: 0;
  padding-left: 3px !important;
  padding-right: 3px !important;
}

.inventory-filter-row {
  margin-left: 0 !important;
  margin-right: 0 !important;
  margin-top: 18px !important;
  width: 100%;
}

.inventory-filter-card {
  align-items: center;
  box-sizing: border-box;
  border-color: #e1e7ef !important;
  cursor: pointer;
  display: flex;
  min-height: 72px;
  padding: 12px 16px;
  width: 100%;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.inventory-filter-card:hover,
.inventory-filter-card:focus {
  border-color: #24326d !important;
  box-shadow: 0 2px 8px rgba(36, 50, 109, 0.12);
  outline: none;
}

.inventory-filter-card--active {
  border: 2px solid #24326d !important;
}

.inventory-filter-icon {
  align-items: center;
  border-radius: 50%;
  display: flex;
  height: 42px;
  justify-content: center;
  margin-right: 14px;
  width: 42px;
}

.inventory-filter-icon--all {
  background: #fff3df;
  color: #f28c28;
}

.inventory-filter-icon--in-stock {
  background: #e9f7ed;
  color: #329447;
}

.inventory-filter-icon--out-stock {
  background: #ffebed;
  color: #e4424f;
}

.inventory-filter-label {
  color: #4d5c70;
  font-size: 15px;
  font-weight: 500;
}

.inventory-filter-count {
  color: #24326d;
  font-size: 17px;
  font-weight: 700;
  margin-left: auto;
}

.inventory-filter-count.inventory-filter-icon--all {
  background: transparent;
  color: #f28c28;
}

.inventory-filter-count.inventory-filter-icon--in-stock {
  background: transparent;
  color: #329447;
}

.inventory-filter-count.inventory-filter-icon--out-stock {
  background: transparent;
  color: #e4424f;
}
</style>
